// extracted by mini-css-extract-plugin
export default {"overlay":"ModalDialog_overlay__tFHH8","content":"ModalDialog_content__+frF+"};